_.mixin(
  (module.exports = {
    deepClone(object) {
      const clone = _.clone(object);
      _.each(clone, (value, key) => {
        if (_.isObject(value)) {
          clone[key] = _.deepClone(value);
        }
      });
      return clone;
    },

    isBlank(obj) {
      if (_.isString(obj)) {
        return !/\S/.test(obj);
      } else {
        return _.isEmpty(obj);
      }
    },

    escapeRegExp(str) {
      if (str != null) {
        return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
      } else {
        return '';
      }
    },
  })
);
